import { useState, useCallback } from 'react';
import { api, GameStateResponse } from '@/lib/api';

interface UseSetGameStateReturn {
  setGameState: (
    keyword: string,
    body: {
      dataType: string;
      data?: string;
      dataBinary?: string;
      version?: number | null;
      checksum?: string;
      metadata?: Record<string, unknown>;
    },
  ) => Promise<GameStateResponse>;
  saving: boolean;
  error: string | null;
}

export function useSetGameState(): UseSetGameStateReturn {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const setGameStateFn = useCallback(
    async (
      keyword: string,
      body: {
        dataType: string;
        data?: string;
        dataBinary?: string;
        version?: number | null;
        checksum?: string;
        metadata?: Record<string, unknown>;
      },
    ): Promise<GameStateResponse> => {
      setSaving(true);
      setError(null);
      try {
        const result = await api.setGameState(keyword, body);
        return result.gameState;
      } catch (err) {
        const msg = err instanceof Error ? err.message : 'Failed to save game state';
        setError(msg);
        throw err;
      } finally {
        setSaving(false);
      }
    },
    [],
  );

  return { setGameState: setGameStateFn, saving, error };
}
